let reqIndex = 0;

export const getReqIndex = () => {
  return reqIndex++;
}
